import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IFetchWorkspaceUsagePercentParams {
  enabled?: boolean;
}

export interface IFetchWorkspaceUsagePercentResponse {
  top_half_of_all_workspaces: boolean;
  top_third_of_all_workspaces: boolean;
}

export default function useFetchWorkspaceUsagePercent({
  enabled = false,
}: IFetchWorkspaceUsagePercentParams): UseQueryResult<
  IFetchWorkspaceUsagePercentResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<IFetchWorkspaceUsagePercentResponse>(
    ["workspace-usage-percent"],
    async (): Promise<IFetchWorkspaceUsagePercentResponse> => {
      return await axios.get(`/v1/workspaces/usage`).then((r) => {
        return r.data as IFetchWorkspaceUsagePercentResponse;
      });
    },
    { enabled }
  );

  return query;
}
